<onyx-section heading="labels.aboutOrder">
  <form [formGroup]="form()" [onyxAutoFocus]="mode()">
    @let controls = form().controls;
    <onyx-dropdown
      [formControl]="controls.sender"
      label="labels.principal"
      [link]="senderLink$ | async"
      [options]="SENDERS_SOURCE"
      [showAddOption]="true"
      [size]="32"
      (selectedOptionValueChange)="changeSender($event.value)"
      (addOption)="addSender()"
    ></onyx-dropdown>

    <onyx-dropdown
      [formControl]="controls.senderBranch"
      label="labels.principalBranch"
      placeholder="labels.mainBranch"
      [options]="senderBranches$ | async"
      [showAddOption]="true"
      [size]="32"
      (addOption)="editSender()"
    ></onyx-dropdown>

    @let ourBranches = ourBranches$ | async;
    @if (ourBranches && ourBranches.length !== 1) {
      <onyx-dropdown
        [formControl]="controls.ourBranch"
        label="labels.ourBranch"
        [options]="ourBranches"
        [size]="32"
      ></onyx-dropdown>
    } @else {
      <div class="placeholder"></div>
    }

    <div class="group">
      <onyx-dropdown
        [formControl]="controls.loadedSemiTrailer"
        label="labels.loadedSemiTrailerPickup"
        [hint]="`${I18N}.externalTrailerHint`"
        [options]="LOADED_SEMI_TRAILER_SOURCE"
        [optional]="true"
        placeholder="labels.no"
        [searchPlaceholder]="`${I18N}.externalTrailerSearch`"
        showAddOption="value"
        [addOptionMessage]="`${I18N}.externalTrailer`"
        [size]="32"
        (optionsChange)="loadedSemiTrailerLoaded$.next()"
        (selectedOptionValueChange)="loadedSemiTrailer$.next($event.value)"
        (addOption)="addExternalTrailer($event!)"
      ></onyx-dropdown>

      @if (controls.loadedSemiTrailer.value != null) {
        <onyx-checkbox
          [formControl]="controls.isDropped"
          label="labels.dropAtPoint"
          [hint]="`${I18N}.dropAtPointHint`"
        ></onyx-checkbox>
      }
    </div>

    <onyx-form-group [controls]="controls.vehicleTypes">
      <onyx-dropdown
        [formControl]="controls.vehicleTypes"
        label="labels.cargoSpace"
        [options]="vehicleTypes$ | async"
        [multiple]="true"
        [search]="true"
        [showErrors]="false"
        [showClear]="!controls.loadedSemiTrailer.value"
        [size]="32"
      ></onyx-dropdown>

      <onyx-suggestions
        [control]="controls.vehicleTypes"
        [suggestions]="vehicleTypeSuggestions$ | async"
        [multiple]="true"
      ></onyx-suggestions>
    </onyx-form-group>

    <onyx-tabs
      [formControl]="controls.minSemiTrailerSize"
      label="labels.minSemiTrailerSize"
      [tabs]="semiTrailerSizes$ | async"
      [fill]="true"
      [onyxTooltip]="
        controls.loadedSemiTrailer.value
          ? `${I18N}.blockedForLoadedSemiTrailer`
          : `${I18N}.unavailableForVans`
      "
      [size]="32"
      width="100%"
      [onyxTooltipDisabled]="
        !(
          controls.minSemiTrailerSize.disabled && !readonlyVehicleRequirements()
        )
      "
    ></onyx-tabs>

    <onyx-dropdown
      [formControl]="controls.dischargeTypes"
      label="labels.dischargeType"
      [multiple]="true"
      [options]="dischargeTypes$ | async"
      [size]="32"
    ></onyx-dropdown>

    <onyx-tabs
      [formControl]="parametersForm().controls.isDedicated!"
      label="labels.orderType"
      [tabs]="IS_DEDICATED_OPTIONS"
      [size]="32"
      [fill]="true"
      width="100%"
    ></onyx-tabs>

    <onyx-text-field
      [formControl]="controls.referenceNumber"
      label="labels.orderReferenceNumber"
      [size]="32"
    ></onyx-text-field>
  </form>
</onyx-section>
